import {SidebarContributors as ContributorsComponent} from '@github-ui/code-view-sidebar/components/SidebarContributors'
import type {SidebarContributorsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarContributors({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'contributors', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/contributors`)
      return (await r.json()) as SidebarContributorsResponse
    },
  })

  if (!data) return null
  return <ContributorsComponent {...data} />
}
